module.exports = __webpack_public_path__ + "img/buzou5.cb680da8.png";